import { createContext } from 'react'

/* Environment Variabes */
export const AppVersion = process.env?.REACT_APP_VERSION
export const AppVersionAnotation = process.env?.REACT_APP_VERSION_ANOTATION || ''
export const ApiUrl = process.env?.REACT_APP_API_URL
export const IsDevelopment = process.env?.NODE_ENV === 'development'
export const SipLogLevel = process.env?.REACT_APP_SIP_LOG_LEVEL
export const IsConferenceDisabled = process.env?.REACT_APP_DISABLE_CONFERENCE
export const EnableRtcConnectionStats = process.env?.REACT_APP_ENABLE_RTCCONNECTIONSTATS
export const DisableDialpadContacts = process.env?.REACT_APP_DISABLE_DIALPAD_CONTACTS
export const KavkomCrmUrl = process.env?.KAVKOM_CRM_URL || 'https://app.kavkom.com/crm/dashboard'
export const KavkomCrmKey = process.env?.KAVKOM_CRM_KEY || 'kavkomcrm'

/* App Globals */
export const MicrophoneMediaStream = {}
export const DefaultKavkomIntegration = {
    key: KavkomCrmKey,
    url: KavkomCrmUrl,
    name: 'Kavkom CRM',
    logo: '/images/logo.png',
    create_contact: true,
    find_contact: true
}

export const ConferenceNumbersDelimiter = ' & ';
export const AppContext = createContext({})
